import React, { useEffect,useState } from "react";
import "./User.css";
import { FaUser, FaLanguage, FaTransgender } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import WeddingFeatures from "../Common/Content/WeddingFeatures/WeddingFeatures";
import Recommendation from "../Common/Content/Reccomendation-Section/Recommendation";

const { ShowUserEvents } = require("../../context/Slice/EventManagementSlice");

const User = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const events = useSelector((state) => state.EventManagementR.Data);
  const isLoading = useSelector((state) => state.EventManagementR.isLoading);
  const [showOverlay, setShowOverlay] = useState(false);

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = secureLocalStorage.getItem("token");
  const disabledCards = {
    budget: true, // Disable Budget card
    guestList: true,
    checkList: true,
    coordinator: true, // Disable Coordinator card
    vendorSearch: true,
  };

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true });

    if (token) {
      const decoded = jwtDecode(token);
      const ID = decoded._id;
      dispatch(ShowUserEvents(ID));
    }
  }, [token, dispatch]);
  console.log(events)

 

  useEffect(()=>{
    async function FetchData(){
      try{
        const res = await fetch(`${BASE_URL}/api/v1/CoordinatorManagement/update-coordinator-events_count`)

        // console.log(data)
      }catch(error){
        console.log(error)
      }

    }
    FetchData()
  },[])

  useEffect(() => {
    // Check if the user has already filled out the budget tool
    const budgetToolCompleted = localStorage.getItem("budgetToolCompleted");
    if (!budgetToolCompleted) {
      setShowOverlay(true);
    }
  }, []);

  const handleBudgetToolClick = () => {
    // Navigate to budget tool and mark it as completed
    localStorage.setItem("budgetToolCompleted", "true");
    setShowOverlay(false);
    navigate("/Budget-tool");
  };

  const dismissOverlay = () => {
    localStorage.setItem("budgetToolCompleted", "true");
    setShowOverlay(false);
  };


  return (
    <div id="use-Dashboard" >
     {showOverlay && (
  <div className="overlay">
    <div className="overlay-content">
      <h2>Welcome! 🎉</h2>
      <p>Please fill out the Budget Tool first before proceeding.</p>
      
      {/* Animated Arrow */}
      <div className="arrow-down">➡</div>

      <button className="budget-tool-btn glow" onClick={handleBudgetToolClick}>
        New Budget Tool
      </button>

      <button className="dismiss-btn" onClick={dismissOverlay}>
         Dismiss
      </button>
    </div>
  </div>
)}


      <div className="container">
        {isLoading || (events && events.length === 0) ? (
          <>
            {/* Budget Tool Button */}
            <button
              className="budget-tool-btn"
              onClick={handleBudgetToolClick}
              disabled={isLoading || (events && events.length > 0)}
            >
              New Budget Tool
            </button>
            <div>
              <WeddingFeatures disabledCards={disabledCards} />
            </div>
          </>
        ) : null}

        {/* Render content only if data is being fetched */}
        {isLoading || (events && events.length > 0) ? (
          <>
            <div className="row align-items-center">
              <div className="centered-container">
                <h1 className="event-heading" data-aos="zoom-in-down">
                  Your Events: A Personalized Timeline
                </h1>
                <p className="event-para" data-aos="zoom-in-down">
                  Explore All Your Special Moments, One Event at a Time
                </p>
              </div>
            </div>
            <div>
              <WeddingFeatures />
              <Recommendation id = {events[0].Coordinator_id} />
            </div>
            <div className="row">
              {events &&
                events.map((event, index) => (
                  <React.Fragment key={index}>
                    <div
                      className="col-md-4"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div className="card profile-header">
                        <h2>Event Coordinator Details</h2>
                        <div className="body">
                          <div className="row">
                            <div className="col-12 mt-3">
                              <p>
                                <FaUser className="me-2" />
                                <strong>Full Name:</strong>{" "}
                                {`${event.Coordinator?.firstName} ${event.Coordinator?.lastName}`}
                              </p>
                              <p>
                                <FaLanguage className="me-2" />
                                <strong>Email:</strong>{" "}
                                {event.Coordinator?.email || "N/A"}
                              </p>
                              <p>
                                <FaLanguage className="me-2" />
                                <strong>Mobile Number:</strong>{" "}
                                {event.Coordinator?.mobile_number || "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="card profile-header"
                        data-aos="fade-up"
                        data-aos-delay="200"
                      >
                        <div className="body">
                          <div className="row">
                            <div className="mt-1">
                              <h2 className="text-center mt-4">Event Notes</h2>
                              {event.Event_Notes &&
                              event.Event_Notes.length > 0 ? (
                                <div className="notes-section">
                                  {event.Event_Notes.map((note, index) => (
                                    <div
                                      key={index}
                                      className="note"
                                      data-aos="fade-right"
                                      data-aos-delay={`${index * 100}`}
                                    >
                                      <h6 className="note-title">
                                        <strong>
                                          {index + 1}. {note.title}
                                        </strong>
                                      </h6>
                                      <p className="note-text">
                                        <em>{note.note}</em>
                                      </p>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <p>No notes available for this event.</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-md-8 vendor-card"
                      data-aos="fade-up"
                      data-aos-delay="300"
                    >
                      <h2>{event.EventName}</h2>
                      <p>
                        <strong>Description:</strong> {event.Description}
                      </p>
                      <p>
                        <strong>Proposed Date:</strong> {event.Proposed_Date}
                      </p>
                      <p>
                        <strong>Start Date:</strong> {event.Start_Date}
                      </p>
                      <p>
                        <strong>End Date:</strong> {event.End_Date}
                      </p>
                      <p>
                        <strong>Location:</strong>{" "}
                        {event.Event_preferences_locations}
                      </p>
                      <p>
                        <strong>Guests:</strong> {event.Guest}
                      </p>
                      <div className="mt-5 ">
                        <h2>Event Vendors</h2>
                        {event.Event_Vendors &&
                        event.Event_Vendors.length > 0 ? (
                          event.Event_Vendors.map((vendor, vIndex) => (
                            <div
                              key={vIndex}
                              className="mt-5 mb-4 "
                              data-aos="fade-left"
                              data-aos-delay={`${vIndex * 100}`}
                            >
                              <p>
                                <strong>{vIndex + 1}. Vendor Name:</strong>{" "}
                                {vendor.serviceName}
                              </p>
                              <p>
                                <strong>Service:</strong> {vendor.category}
                              </p>
                              <p>
                                <strong>City:</strong> {vendor.city}
                              </p>
                              <p>
                                <strong>Address:</strong> {vendor.address}
                              </p>
                            </div>
                          ))
                        ) : (
                          <p>No vendors available</p>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                ))}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default User;
